import {
  Backdrop,
  CircularProgress,
  Typography,
  Button,
  Box,
} from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import QRCode from "react-qr-code";
import { useNavigate } from "react-router-dom";
import CustomSnackbar from "../../../newTestPreo/components/snackbar/Snackbar";
import { toPng } from "html-to-image";
import PrimaryButon from './../../../STMPages/components/customButtons/PrimaryButon';
import PinkSmallButton from "../../../STMPages/components/customButtons/PinkSmallButton";
import PrimarySmallBlueButton from "../../../STMPages/components/customButtons/PrimarySmallBlueButton";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function StudentQRCode() {
  const navigate = useNavigate();
  const qrRef = useRef(null);

  const enquiryId = localStorage.getItem("enquiryId");
  const enquiryPersonalDetailId = localStorage.getItem(
    "enquiryPersonalDetailId"
  );
  const userId = localStorage.getItem("userId");

  const [qrcodeData, setQrcodeData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    if (!userId) {
      navigate("/login");
    }

    const requestData = {
      user_id: parseInt(userId),
      enquiry_personal_detail_id: parseInt(enquiryPersonalDetailId),
    };

    const fetchQrCodeData = async () => {
      try {
        setIsLoading(true);
        const response = await fetch(`${API_ENDPOINT}route/qrbyenquiry`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        });
        const result = await response.json();
        setQrcodeData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
        showSnackbar("Error fetching the qr code", "error");
      } finally {
        setIsLoading(false);
      }
    };

    fetchQrCodeData();
  }, []);

  const downloadQR = () => {
    if (!qrRef.current) return;

    toPng(qrRef.current)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "student_qrcode.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.error(err);
        showSnackbar("Error downloading QR", "error");
      });
  };

  return (
    <Box sx={{ height: "auto", margin: "0 auto", maxWidth: 400, width: "100%", textAlign: "center" }}>
      <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
        <Typography variant="h4" color="error" fontWeight={800} mr={2}>
          Fetching
        </Typography>
        <CircularProgress color="primary" />
      </Backdrop>

      <Typography variant="h3" mb={3}>
        Student Profile QR Code
      </Typography>

      {qrcodeData.length === 0 && !isLoading && (
        <Typography variant="h5">No Data Available</Typography>
      )}

      {qrcodeData.length !== 0 && (
        <>
          <div ref={qrRef} style={{ background: "white", padding: "16px" }}>
            <QRCode
              size={300}
              style={{ height: "auto", maxWidth: "100%", width: "100%" }}
              value={qrcodeData.code}
              viewBox={`0 0 256 256`}
            />
          </div>

          <PrimarySmallBlueButton
            variant="contained"
            sx={{ mt: 3 }}
            onClick={downloadQR}
     buttonTitle="Download QR Code"
          
          />
          
        </>
      )}

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </Box>
  );
}

export default StudentQRCode;